import Main from "./main.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="App">
      <Main />
      <ToastContainer
        position="top-right"
        autoClose={3000} // 3s
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored" // dark | light | colored
      />
    </div>
  );
}

export default App;
